import wx from 'weixin-js-sdk'
import { fetchPost } from '@/assets/js/http.js';
const wxApi = {
  /**
  * [wxRegister 微信Api初始化]
  * @param {Function} callback [ready回调函数]
  */
  wxRegister(callback) {
    let data = {
      url: window.location.href
      // url: "https://hpitree.hphcclub.com/ent/mobile/informationPoster?id=1"
    };
    fetchPost('https://hpitree.hphcclub.com/Mobile/Share/etcshare', // 后台提供接口，获取 wx.config 对象内所需字段
      data
    ).then((res) => {
		wx.config({
			debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
			appId: res.data.appId, // 必填，公众号的唯一标识
			timestamp: res.data.timestamp, // 必填，生成签名的时间戳
			nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
			signature: res.data.signature,// 必填，签名
			jsApiList: ['checkJsApi','onMenuShareTimeline','onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
		});
    }).catch((e) => {
      console.log(e);
    });
    wx.ready((res) => {
      // 如果需要定制ready回调方法
	  
	  wx.checkJsApi({
	     jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
	     success: function(res) {
	  	   // 以键值对的形式返回，可用的api值true，不可用为false
	  	   // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
	     }
	  });
      if (callback) {
        callback();
      };
    });
  },
  ShareTimeline(option) {
    wx.onMenuShareTimeline({
      title: option.title||'惠普打印大客户产品资料“一点通”', // 分享标题
      link: option.link||'', // 分享链接
      imgUrl: option.imgUrl || 'https://hpitree.hphcclub.com/Public/style/assets/images/logoicon.png', // 分享图标
      success() {
        option.success();
      },
      cancel() {
        option.cancel();
      },
      error() {
        option.error();
      }
    })
  },
  ShareAppMessage(option) {
    wx.onMenuShareAppMessage({
      title: option.title || '惠普打印大客户产品资料“一点通”', // 分享标题
      desc: option.desc || '', // 分享描述
      link: option.link || '', // 分享链接
      imgUrl: option.imgUrl || 'https://hpitree.hphcclub.com/Public/style/assets/images/logoicon.png', // 分享图标
      success() {
        option.success();
      },
      cancel() {
        option.cancel();
      },
      error() {
        option.error();
      }
    })
  }
}

export default wxApi